/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Template_VersionInputs */

const en_page_title_new_template_version = /** @type {(inputs: Page_Title_New_Template_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New template version`)
};

const nl_page_title_new_template_version = /** @type {(inputs: Page_Title_New_Template_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe sjabloonversie`)
};

/**
* | output |
* | --- |
* | "New template version" |
*
* @param {Page_Title_New_Template_VersionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_template_version = /** @type {((inputs?: Page_Title_New_Template_VersionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Template_VersionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_template_version(inputs)
	return en_page_title_new_template_version(inputs)
});